import { render, staticRenderFns } from "./DoKoTitle.vue?vue&type=template&id=3253932a&"
import script from "./DoKoTitle.vue?vue&type=script&lang=ts&"
export * from "./DoKoTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports